import React from "react";
import GameInstance from "common/models/game-instance";
import YCComponent from "../yc-component";

class GameComponent extends YCComponent {

    getInstance() {
        return this.props.gameInstance.instance;
    }

    getInstanceId() {
        return this.getInstance()['id'];
    }

    getInstanceProperty(property) {
        return this.getInstance() && this.getInstance().getProperty(property);
    }

    getCurrentNodeType() {
        return this.getInstance() && this.getInstance().getCurrentNodeType();
    }

    isCurrentNodeType(type) {
        return type === this.getCurrentNodeType();
    }

    getProfile() {
        return this.getInstance() && this.getInstance().getProfile();
    }

    getProfileProperty(property) {
        return this.getInstance() && this.getInstance().getProfileProperty(property);
    }

    getHousing() {
        return this.getInstance() && this.getInstance().getHousing();
    }

    getFood() {
        return this.getInstance() && this.getInstance().getFood();
    }

    getTransportation() {
        return this.getInstance() && this.getInstance().getTransportation();
    }

    getHousingInsurance() {
        return this.getInstance() && this.getInstance().getHousingInsurance();
    }

    getTransportationInsurance() {
        return this.getInstance() && this.getInstance().getTransportationInsurance();
    }

    getNodeId(type) {
        let node = this.getInstance()['nodes'].find((node) => node.type === type)
        return node ? node.id : null;
    }

    getNodeIndex(type) {
        const nodes = ["Nodes::IntroNode", "Nodes::Round01Node", "Nodes::Round02Node", "Nodes::Round03Node", "Nodes::FinalNode"];
        return nodes.findIndex((nodeType) => type === nodeType);
    }

    compareNodeType(type) {
        let current = this.getCurrentNodeType();

        if (current === type)
            return 0;

        if (this.getNodeIndex(current) < this.getNodeIndex(type)) {
            return 1;
        } else {
            return -1;
        }
    }

    getActiveEvent() {
        return this.props.gameInstance.instance.getActiveEvent();
    }

    questionsRequired() {
        return this.getInstanceProperty('PROFILE_COMPLETE');
    }

}

export default GameComponent;
